<template>
  <div ref="layout" class="page-form page-base">
    <h3 class="title">销售计划变更单{{ mode === 'edit' ? '': '创建' }}</h3>

    <div class="form-container">
      <errors-list :errors="errorList" />
      <div class="tools">
        <!-- 页面详情状态 -->
        <form-button v-if="mode == 'edit'" @click="$router.go(-1)">返回</form-button>
        <!-- 页面新建状态 -->
        <template v-if="$_has(['WLY002', 'WLY004', 'WLYALL']) && !conditions.plan_order">
          <form-button type="primary" @click="changeStatus('SAVE')">保存</form-button>
          <form-button icon="form-advance" @click="changeStatus('SUBMIT')">提交</form-button>
        </template>
        <template v-if="conditions.plan_order">
          <template v-if="$_has(['WLY002', 'WLY004', 'WLYALL'])">
            <template v-if="conditions.porder_status === 'E006'">
              <form-button @click="copyOrder">复制</form-button>
            </template>
            <template v-else>
              <form-button v-if="!showEdit" @click="showEdit = true">修改</form-button>
              <form-button @click="copyOrder">复制</form-button>
            </template>
          </template>
        </template>

        <!-- 修改状态 -->
        <template v-if="showEdit">
          <form-button @click="showEdit = false">显示</form-button>
          <template v-if="$_has(['WLY002', 'WLY004', 'WLYALL'])">
            <template v-if="conditions.porder_status === 'E001'">
              <form-button type="primary" @click="changeStatus('SAVE')">保存</form-button>
              <form-button icon="form-advance" @click="changeStatus('SUBMIT')">提交</form-button>
            </template>
            <template v-if="conditions.porder_status === 'E002'">
              <form-button icon="form-advance" @click="changeStatus('SUBMIT')">提交</form-button>
              <form-button @click="changeStatus('CANCEL')">取消</form-button>
            </template>
            <template v-if="conditions.porder_status === 'E005'">
              <form-button icon="form-advance" @click="changeStatus('SUBMIT')">提交</form-button>
            </template>
          </template>

          <template v-if="conditions.porder_status === 'E003'">
            <template v-if="$_has(['WLYALL', 'WLY002'])">
              <form-button @click="changeStatus('APPROVE')">审核通过</form-button>
              <form-button @click="changeStatus('REJECT')">审核拒绝</form-button>
            </template>
            <template v-if="$_has(['WLYALL', 'WLY002', 'WLY004'])">
              <form-button @click="changeStatus('CANCEL')">取消</form-button>
            </template>
          </template>

          <template v-if="conditions.porder_status === 'E004' && conditions.cancel">
            <form-button @click="changeStatus('CANCEL')">取消</form-button>
          </template>
        </template>
      </div>
      <el-form ref="form" inline size="mini" :show-message="false" label-width="140px" :disabled="isEdit" :model="conditions" :rules="rules">
        <common-title title="基本信息" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item prop="plan_number" class="line-16" label="销售计划编号">
              <wly-input
                v-model="conditions.plan_number"
                input-type="salePlan"
                @enter="handleEnter"
                @handleSuffixClick="openSelectDialog"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="单据编号">
              <el-input
                v-model="conditions.plan_order"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="单据类型">
              <el-input value="销售计划变更单" disabled />
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item label="提报类型">
              <el-select
                v-model="conditions.report_type"
                placeholder=""
                disabled
              >
                <el-option v-for="item in selectDataOptions['A0001']" :key="item.id" :value="item.value" :label="item.name" />

              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户编号">
              <el-input
                v-model="conditions.customer"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户名称">
              <el-input
                v-model="conditions.cust_name"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户类型">
              <el-select
                v-model="conditions.customer_type"
                placeholder=""
                clearable
              >
                <el-option
                  v-for="item in selectDataOptions['A0009']"
                  :key="item.id"
                  :value="item.value"
                  :label="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="计划类型">
              <el-select
                v-model="conditions.plan_type"
                placeholder=""
                disabled
              >
                <el-option v-for="item in selectDataOptions['A0002']" :key="item.id" :value="item.value" :label="item.name" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="存货分类">
              <el-select
                v-model="conditions.wlybrand"
                placeholder=""
                disabled
                filterable
              >
                <el-option v-for="item in selectDataOptions['A0019']" :key="item.id" :value="item.value" :label="item.name" />

              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="年度">
              <el-date-picker
                v-model="conditions.gjahr"
                type="year"
                format="yyyy"
                value-format="yyyy"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="月份">
              <el-date-picker
                v-model="conditions.monat"
                type="month"
                format="MM"
                value-format="MM"
                placeholder=""
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="adj_reason" label="变更原因">
              <el-select
                v-model="conditions.adj_reason"
                placeholder=""
                type="select"
                clearable
              >
                <el-option
                  v-for="item in selectDataOptions['A0003']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="签约审批单号" prop="approval_no">
              <el-input
                v-model="conditions.approval_no"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="备注">
              <el-input
                v-model="conditions.remark"
                type="textarea"
                clearable
                rows="4"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="区域" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="营销单元">
              <el-input
                v-model="conditions.sal_center_name"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="省份">
              <el-input v-model="conditions.region_text" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="城市">
              <el-input v-model="conditions.city_text" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="业务员">
              <el-input
                v-model="conditions.sales_emp_name"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="状态" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="创建人">
              <el-input
                v-model="conditions.uname"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建日期">
              <el-input
                v-model="conditions.datum"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="状态">
              <el-select
                v-model="conditions.porder_status"
                placeholder=""
                type="text"
                clearable
                disabled
              >
                <el-option v-for="item in selectDataOptions['A0025']" :key="item.id" :value="item.value" :label="item.name" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="审核意见">
              <el-input
                v-model="conditions.audit_comment"
                type="textarea"
                rows="4"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="现有计划量" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view line-16" label="总计划量(件)">
              <el-input
                v-model="conditions.total_qty"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view line-16" label="初始计划量(件)">
              <el-input
                v-model="conditions.initplan_qty"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view line-16" label="已开票计划量(件)">
              <el-input
                v-model="conditions.billing_qty"
                type="text"
                name=""
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view line-16" label="已占用计划量(件)">
              <el-input
                v-model="conditions.atp_qty"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view line-16" label="剩余可用计划量(件)">
              <el-input
                v-model="conditions.remain_qty"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          </el-row>
          <el-row>
          <el-col :lg="8" :md="12">
            <el-form-item  label="总计划量(瓶)">
              <el-input
                v-model="conditions.total_bot"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view line-16" label="初始计划量(瓶)">
              <el-input
                v-model="conditions.initplan_bot"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view line-16" label="已开票计划量(瓶)">
              <el-input
                v-model="conditions.billing_bot"
                type="text"
                name=""
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view line-16" label="已占用计划量(瓶)">
              <el-input
                v-model="conditions.atp_bot"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view line-16" label="剩余可用计划量(瓶)">
              <el-input
                v-model="conditions.remain_bot"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="计划量" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item
              prop="curnt_adjqty"
              class="widget-view line-16"
              label="本次调整计划量(件)"
            >
              <el-input
                v-model="conditions.curnt_adjqty"
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item
              prop="curnt_adjbot"
              class="widget-view line-16"
              label="本次调整计划量(瓶)"
            >
              <el-input
                v-model="conditions.curnt_adjbot"
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item
              prop="futur_adjqty"
              class="widget-view line-16"
              label="未调整计划量(件)"
            >
              <el-input
                v-model="conditions.futur_adjqty"
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="现有计划额（参考）" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view line-16">
              <template #label>
                总计划额<br>(万元)
              </template>
              <el-input
                v-model="conditions.total_amt"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view line-16">
              <template #label>
                初始计划额<br>(万元)
              </template>
              <el-input
                v-model="conditions.initplan_amt"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view line-16" label="已扣减计划额(万元)">
              <el-input
                v-model="conditions.billing_amt"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view line-16" label="已占用计划额(万元)">
              <el-input
                v-model="conditions.atp_amt"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view line-16" label="剩余可用计划额(万元)">
              <el-input
                v-model="conditions.remain_amt"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="计划额（参考）" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item
              prop="curnt_adjamt"
              class="widget-view line-16"
              label="本次调整计划额(万元)"
            >
              <el-input
                v-model="conditions.curnt_adjamt"
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view line-16" label="未调整计划额(万元)">
              <el-input
                v-model="conditions.futur_adjamt"
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon
        title="状态变更记录"
        :custome-config="() => vxeShowCustom('xTable')"
      >
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          align="center"
          size="mini"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        />
      </TableCommon>

      <TableCommon title="附件" :custome-config="() => vxeShowCustom('fileTable')">
        <template #button>
          <el-upload
            ref="upload"
            accept=".png,.pdf,.jpg"
            action=""
            :on-change="uploadFile"
            :show-file-list="false"
            :auto-upload="false"
          >
            <table-button slot="trigger" :disabled="isEdit" name="upload" tip="上传" />
          </el-upload>
          <table-button name="delete" :disabled="isEdit" tip="删除" @click="delUpload" />
        </template>
        <vxe-grid
          ref="fileTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsFile.columns"
          :data="gridOptionsFile.data"
        >
          <template #filename="{row}">
            <span class="blue" @click="downLoadFile(row)">{{ row.filename }}</span>
          </template>
        </vxe-grid>
      </TableCommon>
    </div>

    <!-- 选择通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      title="销售计划选择"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showDialog">
        <sale-plan ref="dialogEdit" />
      </template>

      <div slot="footer">
        <el-button type="default" size="small" icon="el-icon-circle-close" @click="showDialog = false">取消</el-button>
        <el-button type="primary" size="small" icon="el-icon-circle-check" @click="submitHandle">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { getSalePlanByNumber, apiSalePlanChangeCreate } from '@/api/sap/sale-plan'
import { apiSapClientFindInfo } from '@/api/common'
const SalePlan = () => import('@/components/dialog/SalePlan.vue')
import { mapState } from 'vuex'
import { formatSapFileSize } from '@/mixins/index'
import { sapDownloadFile } from '@/utils/frontExport'

// reportTypeTextView planTypeTextView stockTypeTextView billStatusTextView saleCenterName customerTypeTextView

export default {
  components: {
    SalePlan
  },
  data() {
    const rules = {
      plan_number: [{ required: true, message: '请选择销售计划编号', trigger: 'change' }],
      adj_reason: [{ required: true, message: '请选择变更原因', trigger: 'change' }],
      curnt_adjqty: [
        { required: true, message: '请输入本次调整计划量', trigger: 'blur' },
        { max: 18, message: '最大18个字符', trigger: 'blur' }
      ],
      futur_adjqty: [
        { message: '请输入未调整计划量', trigger: 'blur' },
        { max: 18, message: '最大18个字符', trigger: 'blur' }
      ],
      curnt_adjamt: [
        { required: true, message: '请输入本次调整计划额', trigger: 'blur' },
        { max: 18, message: '最大18个字符', trigger: 'blur' }
      ]
    }
    return {
      rules,
      mode: 'add',
      showEdit: false,
      showDialogType: '',
      errorList: [],
      showDialog: false,
      dialogTitle: '',
      selectDataOptions: {},
      loading: false,
      conditions: {
        uname: '',
        datum: '',
        porder_status: 'E001',
        sal_center_name: '',
        plan_number: '',
        plan_order: '',
        report_type: '',
        customer: '',
        cust_name: '',
        customer_type: '',
        plan_type: '',
        wlybrand: '',
        gjahr: '',
        monat: '',
        adj_reason: '',
        sal_center: '',
        region: '',
        region_text: '',
        city_text: '',
        city: '',
        order_type: 'ZP02',
        sales_emp_name: '',
        total_qty: '',
        initplan_qty: '',
        billing_qty: '',
        atp_qty: '',
        remain_qty: '',
        total_amt: '',
        initplan_amt: '',
        billing_amt: '',
        atp_amt: '',
        remain_amt: '',
        curnt_adjqty: '',
        curnt_adjbot: '',
        futur_adjqty: '',
        curnt_adjamt: '',
        futur_adjamt: '',
        remark: '',
        audit_comment: '',
        total_bot: '',
        initplan_bot: '',
        billing_bot: '',
        atp_bot: '',
        remain_bot: '',
      },
      gridOptions: {
        data: [],
        columns: [
          { field: 'operationer', title: '操作员' },
          { field: 'oper_name', title: '操作员姓名' },
          { field: 'oper_status_text', title: '操作状态' },
          { field: 'changin_date', title: '变更日期' },
          { field: 'changin_time', title: '变更时间' }
        ]
      },
      gridOptionsFile: {
        columns: [
          { type: 'checkbox', title: '', field: 'checkbox', width: 40 },
          { field: 'filename', title: '附件名称', slots: { default: 'filename' }},
          { field: 'mimetype', title: '附件类型' },
          {
            field: 'filelength',
            title: '大小',
            formatter: ({ cellValue }) => formatSapFileSize(cellValue)
          },
          {
            field: 'created_date',
            title: '上传日期',
            formatter: ({ cellValue }) => {
              if (!cellValue) return ''
              const dateStr = String(cellValue)
              if (dateStr.length === 8) {
                return dateStr.substring(0, 4) + '-' + dateStr.substring(4, 6) + '-' + dateStr.substring(6, 8)
              }
              return cellValue
            }
          },
          {
            field: 'created_time',
            title: '上传时间',
            formatter: ({ cellValue }) => {
              if (!cellValue) return ''
              const timeStr = String(cellValue)
              if (timeStr.length === 6) {
                return timeStr.substring(0, 2) + ':' + timeStr.substring(2, 4) + ':' + timeStr.substring(4, 6)
              }
              return cellValue
            }
          }
        ],
        data: [],
        delData: []
      }
    }
  },
  computed: {
    ...mapState('user', ['userInfo']),
    isBtnsShow() {
      return !['E004', 'E006'].includes(this.conditions.porder_status)
    },
    isEdit() {
      if (this.conditions.plan_order) {
        return !this.showEdit
      } else {
        return false
      }
    }
  },
  created() {
    // 销售计划变更原因 字典：A0003
    this.getSelectDictDataOrigin('A0003')
    this.getSelectDictDataOrigin('A0025')
    this.getSelectDictDataOrigin('A0001')
    this.getSelectDictDataOrigin('A0002')
    this.getSelectDictDataOrigin('A0019')
    this.getSelectDictDataOrigin('A0009')

    const params = this.$route.params
    // 变更编辑单
    if (this.$route.query.order && !Reflect.ownKeys(params).length) {
      this.mode = 'edit'
      this.salePlanCountFindById()
    } else if (Reflect.ownKeys(params).length) {
      Object.assign(this.conditions, params)
      this.conditions.uname = this.$store.getters.role.login_user
      this.conditions.datum = this.$utilsCommon.parseTime(new Date().getTime(), '{y}-{m}-{d}')
    } else {
      this.conditions.uname = this.$store.getters.role.login_user
      this.conditions.datum = this.$utilsCommon.parseTime(new Date().getTime(), '{y}-{m}-{d}')
    }
  },

  methods: {
    // 保存 提交 取消
    changeStatus(mode) {
      this.$refs['form'].validate(async(valid, err) => {
        if (valid) {
          try {
            this.loading = true
            const params = {
              iv_mode: mode,
              user_bp: this.$store.getters.role.USER_BP,
              data: this.conditions,
              history: this.gridOptions.data,
              attachment: this.gridOptionsFile.data.concat(this.gridOptionsFile.delData)
            }
            this.errorList = []
            const res = await apiSalePlanChangeCreate(params)
            if (res?.msg_type !== 'S') {
              this.errorList.push(res.message)
              return
            }
            this.$message.success(res.message)
            this.showEdit = false
            Object.assign(this.conditions, res.info)
            this.conditions.cancel = res.cancel
            this.gridOptions.data = res.history
            this.gridOptionsFile.delData = []
            if (res.attachment) {
              this.gridOptionsFile.data = res.attachment
            }
          } catch (error) {
            //
          }
          this.loading = false
        } else {
          this.errorList = this.$utilsCommon.filterErrorMsg(err)
          return false
        }
      })
    },
    copyOrder() {
      const resetFields = [
        'plan_order',
        // 'plan_number',
        'futur_adjqty',
        'futur_adjamt',
        'change_name',
        'uzeit',
        'timestamp',
        'mdate',
        'mtime',
        'mname',
        'mtimestamp',
        'porder_status'
      ]
      if (this.mode === 'add') {
        resetFields.forEach(key => {
          if (key === 'porder_status') {
            this.conditions[key] = 'E001'
          } else {
            this.conditions[key] = ''
          }
        })
        this.gridOptions.data = []
        this.gridOptionsFile.data = []
        this.gridOptionsFile.delData = []
        this.showEdit = false
      } else {
        const params = { ...this.conditions }
        resetFields.forEach(key => {
          if (key === 'porder_status') {
            params[key] = 'E001'
          } else {
            params[key] = ''
          }
        })
        this.$router.replace({
          name: '10.02 销售计划变更单创建',
          params
        })
      }
    },
    async salePlanCountFindById() {
      const { data } = await getSalePlanByNumber({ plan_order: this.$route.query.order })
      Object.assign(this.conditions, data?.ls_head || {})
      this.conditions.cancel = data.cancel
      this.initCustomer()
      this.gridOptions.data = data?.lt_chg_history || []
      this.gridOptionsFile.data = data?.attachment || []
    },
    async initCustomer() {
      const params = {
        rt_partner: [
          {
            SIGN: 'I',
            OPTION: 'EQ',
            LOW: this.conditions.customer,
            HIGH: ''
          }
        ],
        page: 1,
        pagesize: 50
      }
      // 当前登录账号和角色
      params.partner = this.$store.getters.role.USER_BP
      params.role = this.$store.getters.role.ROLE
      const { data } = await apiSapClientFindInfo(params)
      if (data.length) {
        this.conditions.sales_emp_name = data[0].sales_emp_name
        this.conditions.sales_emp = data[0].sales_emp
        this.$set(this.selectDataOptions, 'orgList', data[0].yxdy)
      }
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    // 控件回车
    async handleEnter(e, type, data) {
      if (typeof type === 'object') {
        this.errorList ? (this.errorList = [type.message]) : this.$message.error(type.message)
        return
      }
      if (!data) return

      Object.assign(this.conditions, data.head)
      this.conditions.porder_status = 'E001'
      this.conditions.order_type = 'ZP02'
      this.conditions.uname = this.$store.getters.role.login_user
      this.conditions.datum = this.$utilsCommon.parseTime(new Date().getTime(), '{y}-{m}-{d}')
    },
    // 弹窗关闭前操作
    beforeClose(done) {
      done()
    },
    // 打开窗口
    openSelectDialog(e) {
      e.target.blur()
      this.showDialog = true
    },
    // 弹窗内的方法这边来处理，方便数据回调在本页面处理
    submitHandle() {
      this.$refs.dialogEdit.submitForm().then(res => {
        if (res) {
          Object.assign(this.conditions, res)
        }
        this.showDialog = false
      })
    },
    // 获取文件后缀
    getFileExtension(filename) {
      const parts = filename.split('.')
      return parts.length > 1 ? parts.pop().toLowerCase() : ''
    },
    // 上传文件
    async uploadFile(file) {
      const _this = this
      const reader = new FileReader()
      reader.readAsArrayBuffer(file.raw)
      var strArr = []
      reader.onload = function() {
        var unitArray = new Uint8Array(this.result)
        for (var i = 0; i < unitArray.length; i++) {
          var u_arr16 = unitArray[i].toString(16).toLocaleUpperCase()
          if (u_arr16.length < 2) {
            u_arr16 = '0' + u_arr16
          }
          strArr.push(u_arr16)
        }

        strArr = strArr.join('')
        const dateTime = new Date().getTime()
        const fileExtension = _this.getFileExtension(file.name)
        const fileData = {
          filename: file.name,
          mimetype: fileExtension,
          doc_type: fileExtension,
          xcontent: strArr,
          filelength: file.size,
          zzfld00002d: _this.$store.getters.role.USER_BP,
          zzfld00002d_dscr: _this.$store.getters.role.login_user,
          created_date: _this.$utilsCommon.parseTime(dateTime, '{y}{m}{d}'),
          created_time: _this.$utilsCommon.parseTime(dateTime, '{h}{i}{s}')
        }

        _this.gridOptionsFile.data.unshift(fileData)
      }
    },
    // 删除附件
    delUpload() {
      const checkedList = this.$refs.fileTable.getCheckboxRecords()
      if (!checkedList.length) return this.$message.warning('请选择有效的数据！')
      checkedList.forEach(file => {
        file.delete_flag = 'X'
        const index = this.gridOptionsFile.data.findIndex(v => v._X_ID === file._X_ID)
        this.gridOptionsFile.data.splice(index, 1)
      })
      if (this.conditions.plan_order) {
        this.gridOptionsFile.delData = this.gridOptionsFile.delData.concat(
          checkedList.filter(v => v.attach_id)
        )
      }
    },
    // 下载文件
    downLoadFile(row) {
      sapDownloadFile(row.xcontent, row.filename)
    }
  }
}
</script>

<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/sale-plan-manage/salePlanChangeEdit.vue